module.exports = __webpack_public_path__ + "files/a4fe3d226163a0343dfb89f5aae1597e.png";